<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12 col-md-6">
    <app-checkbox-form-field
      formControlName="engageApps"
      [label]="'case.fields.engageApps.label' | translate"
      [helpText]="'case.fields.engageApps.help'"
      [viewMode]="viewMode"
    ></app-checkbox-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-datepicker-form-field
      formControlName="engageAppsDate"
      [label]="'case.fields.engageAppsDate.label' | translate"
      [helpText]="'case.fields.engageAppsDate.help'"
      [viewMode]="viewMode"
  ></app-datepicker-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="appsAdditionalInfo"
      [label]="'case.fields.appsAdditionalInfo.label' | translate"
      [helpText]="'case.fields.appsAdditionalInfo.help'"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
</div>
